import eventEmitter, { events } from 'core/events/eventEmitter';
import progressStorage from 'core/progressStorage';
import { updateAccessibilitySettings } from 'store/accessibility/actions';
import { ThunkResult } from '../../types';
import { ActionTypes } from './types';

export const toggleCheck = (data: ToggleCheckData): ThunkResult => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.TOGGLE_CHECK,
    payload: {
      [data.itemId]: {
        isChecked: data.isChecked
      }
    }
  });
  eventEmitter.emit(events.UPDATE_CHECKLIST_PROGRESS, {
    id: data.itemId,
    isChecked: data.isChecked,
    state: getState()
  });
};

export const initChecklist = (
  checklist: string[]
): ThunkResult<Promise<void>> => async dispatch => {
  await progressStorage.restoreProgress();

  dispatch(
    updateAccessibilitySettings(
      await progressStorage.mergeAccessibilitySettings(
        await progressStorage.loadLocalAccessibilitySettings()
      )
    )
  );
  const payload: CheckListItem = {};
  const checklistItems = progressStorage.checklistItem || {};

  checklist.forEach(item => {
    payload[item] = { isChecked: checklistItems[item] || false };
  });

  await dispatch({
    type: ActionTypes.INIT_CHECKLIST,
    payload
  });
};

interface ToggleCheckData {
  itemId: string;
  isChecked: boolean;
}

interface CheckListItem {
  [key: string]: {
    isChecked: boolean;
  };
}
